import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { PortalAppImportDataRequest } from "./portal-app-import-data-request";
import { PortalAppExportRequest } from "./portal-app-export-request";
import { PABatchEmailRequest } from "./pa-batch-email-request";

@Injectable()
export class DataService_PortalAppBatchRegistration {
	constructor(private httpclientService: HttpclientService) {}

	PortalAppImportDataSelectList(parms: PortalAppImportDataRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppImportDataSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalAppExportSelectList(parms: PortalAppExportRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppExportSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GradeLevelSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/GradeLevelRPTGetList?ApplicationItemID=&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AcademySelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/AcademyGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HomeroomSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/HomeroomGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/GroupGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonTypeSelectList() {
		var postResult$ = new Subject();
		var url = "Report/PERSONTYPEGetList?ApplicationItemID=&SchoolID=0";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalAppBatchEmail(parms: PABatchEmailRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppBatchEmail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
